var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fedd00",
    d: "M0 0h53.3v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0h26.7v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m3.1 0 10.2 7.5L23.4 0h3.3v2.6l-10 7.4 10 7.5V20h-3.4l-10-7.5-10 7.5H0v-2.5l10-7.4L0 2.7V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "m17.7 11.7 9 6.6V20l-11.3-8.3zm-7.7.8.3 1.5-8 6H0zM26.7 0v.1L16.3 8V6l8.4-6zM0 0l10 7.3H7.5L0 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 0v20h6.7V0zM0 6.7v6.6h26.7V6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M0 8v4h26.7V8zm11.4-8v20h4V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M13.3 13.4a3.4 3.4 0 1 0 0-6.8 3.4 3.4 0 0 0 0 6.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fedd00",
    d: "m13.3 6.6 2 6.2-5.2-3.9h6.5l-5.3 3.9M5.6 8.2l1.1 3.6-3-2.2h3.8l-3.1 2.2M21 8.2l1.2 3.6-3-2.2H23l-3 2.2m-6.7 3 1.2 3.7-3-2.3h3.7l-3 2.3m1.1-17 1.2 3.6-3-2.2h3.7l-3 2.2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNu);
export default __webpack_public_path__ + "static/media/nu.b1e2c5b7cb813bdad8620bd50b7516cf.svg";
export { ForwardRef as ReactComponent };